import { jsx as _jsx } from "react/jsx-runtime";
import styled, { css } from 'styled-components';
import { breakpoint, mr, ml, mt } from '@nib/layout';
import { formBorderColorValid, formBorderColorInvalid } from '@nib-components/theme';
import { TickSystemIcon, ErrorSystemIcon } from '@nib/icons';
import { disabledOpacity } from '../disabled';
// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const PositionIcon = styled(_ref => {
  let {
    isCompact,
    isFieldset,
    outside,
    ...rest
  } = _ref;
  return /*#__PURE__*/_jsx("span", {
    ...rest
  });
})`
  position: absolute;
  font-size: 0;
  top: 50%;
  transform: translateY(-50%);
  inset-inline-end: 0.5rem;

  ${breakpoint('mini')`
    inset-inline-end: ${_ref2 => {
  let {
    isCompact
  } = _ref2;
  return isCompact ? '0.5rem' : '1rem';
}};
  `}

  ${_ref3 => {
  let {
    isFieldset
  } = _ref3;
  return isFieldset && css`
      display: inline-block;
      ${mt(2)};
      ${mr(2)};
      position: static;
      align-self: center;
      transform: none;
    `;
}}

  ${_ref4 => {
  let {
    outside
  } = _ref4;
  return outside && css`
      &&& {
        ${ml(2)};
        inset-inline-end: auto;
      }
    `;
}}

  ${_ref5 => {
  let {
    disabled
  } = _ref5;
  return disabled && css`
      opacity: ${disabledOpacity};
    `;
}};
`;
const StyledTick = styled(TickSystemIcon)`
  color: var(--themeColorFgSuccess, ${formBorderColorValid});
`;
const StyledError = styled(ErrorSystemIcon)`
  color: var(--themeColorFgError, ${formBorderColorInvalid});
`;
const ValidationIcon = _ref6 => {
  let {
    valid,
    outside,
    isFieldset,
    isCompact,
    disabled,
    ...rest
  } = _ref6;
  return /*#__PURE__*/_jsx(PositionIcon, {
    outside: outside,
    isFieldset: isFieldset,
    isCompact: isCompact,
    disabled: disabled,
    ...rest,
    "data-mesh-component": "FORM-CONTROL--VALIDATION-ICON",
    children: valid ? /*#__PURE__*/_jsx(StyledTick, {
      "data-testid": "tick-icon",
      size: isCompact ? 20 : 'sm',
      fill: "currentColor"
    }) : /*#__PURE__*/_jsx(StyledError, {
      "data-testid": "error-icon",
      size: isCompact ? 20 : 'sm',
      fill: "currentColor"
    })
  });
};
export default ValidationIcon;